import { UncontrolledTabs } from './UncontrolledTabs';
import { UncontrolledTabsNavLink } from './UncontrolledTabsNavLink';
import { UncontrolledTabsTabContent } from './UncontrolledTabsTabContent';

UncontrolledTabs.NavLink = UncontrolledTabsNavLink;
UncontrolledTabs.TabContent = UncontrolledTabsTabContent;

export default UncontrolledTabs;
